function queue() {
	const elId = '#app-queue';
	const elClass = '.js-vue-queue';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;

	const app = new Vue({
		el: elId,
		data: {
			search: {
				field: null,
				currentkeyword: null
			},
			results: {
				found: 0,
				count: 0,
				items: [],
				fullitems: [],
				selected: null
			},
			download: {
				username: undefined,
				password: undefined,
				result: null
			},
			pagination: {
				max: 999,
				pagesize: 10,
				currentpage: 0
			},
			error: null,
			modal: null
		},
		created: function() {
			this.fetchData();
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');

			window.setInterval(this.reloadQueue, 10000);
		},
		methods: {
			fetchData: function() {
				toggleLoader(true);
				this.reloadQueue();
			},
			reloadQueue: function() {
				const self = this;
				GET('/baas/Nominow_Queue/queue')
					.then(xhr => {
						self.error = null;
						const response = JSON.parse(xhr.responseText);
						if (response.ErrorCode == '401') {
							self.error = response.Message;
							$(elClass).removeClass('is-creating');
							toggleLoader(false);
							return;
						}
						const queue = Array.prototype.map.call(response, el => ({
							_id: el._id,
							QueueId: el.QueueId,
							Name: el.Name,
							Type: el.Type,
							Status: el.Status,
							CreateDate: window.formatDateTime(el.CreateDate),
							ModifyDate: window.formatDateTime(el.ModifyDate),
							StatusClass: el.Status == 'Finished' ? 'has-text-success' : 'has-text-danger'
						}));
						queue.splice(0, 0, {
							Name: 200,
							Type: 50,
							Status: 50,
							CreateDate: 50,
							ModifyDate: 50
						});
						self.results.fullitems = queue;
						self.results.items = queue;
						self.results.count = queue.length - headerHandicap;
						$(elClass).removeClass('is-creating');
						toggleLoader(false);
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						$(elClass).removeClass('is-creating');
						toggleLoader(false);
					});
			},
			doSearch: function() {
				const self = this;
				/* in this case, we're searching the existing list instead of making a get call, so there's no loading going on in this search function */
				if (isLoading() || self.search.field == null) {
					return;
				}
				self.search.currentkeyword = self.search.field;
				const search = this.search.currentkeyword.toLowerCase();
				if (!search) {
					self.results.items = self.results.fullitems;
					self.results.found = 0;
					self.search.currentkeyword = null;
				} else {
					const newQueue = [];
					/* header */
					newQueue.push(self.results.fullitems[0]);

					for (let i = 1; i < self.results.fullitems.length; i++) {
						const q = self.results.fullitems[i];
						const arr = Array.prototype.map.call(Object.keys(q), a => q[a]);
						let txt = Array.prototype.join.call(arr, ' ');
						txt = txt.toLowerCase();
						if (txt.indexOf(search) > -1) {
							newQueue.push(q);
						}
					}
					self.results.items = newQueue;
					self.results.found = newQueue.length - headerHandicap;
				}
				self.pagination.currentpage = 0;
			},
			selectItem: function(item, ix) {
				const self = this;
				this.download.username = undefined;
				this.download.password = undefined;
				if (item.Status != 'Cancelled') {
					this.results.selected = item;
				}
				toggleLoader(false);
			},
			closemodals: function() {
				this.results.selected = null;
			},
			downloadItem: function() {
				const self = this;
				toggleLoader(true);
				const payload = {
					queueId: this.results.selected.QueueId,
					username: this.download.username,
					password: this.download.password
				};
				POST('/baas/nominow_insight/downloadinsightaction', payload, 60000)
					.then(xhr => {
						const response = JSON.parse(xhr.responseText);
						if (response.status) {
							window.openb64FileDownload(response.fileContent, response.filename, 'text/plain');
							self.download.username = undefined;
							self.download.password = undefined;
							self.results.selected = null;
						} else if (response.Message) {
							window.initToast(response.Message, 'error');
						} else {
							window.initToast(xhr.responseText, 'error');
						}
						toggleLoader(false);
					})
					.catch(xhr => {
						self.download.result = xhr.responseText;
						toggleLoader(false);
					});
			},
			cancelQueueItem: function() {
				const self = this;

				this.modal = window.deleteConfirmComponent(
					self,
					() => {
						const payload = {
							filter: JSON.stringify({ _id: self.results.selected._id }),
							json: JSON.stringify({ Status: 'Cancelled' }),
							patch: true
						};
						PUT('/baas/nominow_insight/cancelinsightaction', payload).then(xhr => {
							self.fetchData();
							self.results.selected = null;
							self.modal = null;
						});
					},
					'Cancel queue task',
					null,
					'Cancel Task'
				);
			},
			getTableRowClass: function(item, index) {
				if (item.Status == 'Cancelled') {
					return 'has-text-light';
				}
				return null;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
queue();
